// extracted by mini-css-extract-plugin
export default {"form":"EditarClienteGlobal_form__Hz9-n","areaBtn":"EditarClienteGlobal_areaBtn__8RbNr","btn":"EditarClienteGlobal_btn__J-Qyc"};